import { z } from "zod";

export const idNameSchema = z.object({
	id: z.number(),
	name: z.string(),
});

export type IdName = z.infer<typeof idNameSchema>;
